import { useState } from "react";

import {
  WIDGET_TYPES,
  AGGREGATIONS,
  METRICS,
  BUCKETS,
  CHARTS,
  getReportFields,
  getDateFields,
  newWidget
} from "../reportWidgets";

export default function ReportBuilder({
  widgets,
  templateColumns,
  actionColumns,
  addReportWidget,
  updateReportWidget,
  removeReportWidget,
  moveReportWidget
}) {
  const [newType, setNewType] = useState("kpi");

  const fields = getReportFields(templateColumns);
  const dateFields = getDateFields(templateColumns);

  const set = (id, patch) => updateReportWidget(id, patch);

  const renderParams = (widget) => {
    if (widget.type === "kpi") {
      return (
        <>
          <label>Поле
            <select value={widget.field || "amount"} onChange={(e) => set(widget.id, { field: e.target.value })}>
              {fields.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
            </select>
          </label>

          <label>Агрегация
            <select value={widget.agg || "sum"} onChange={(e) => set(widget.id, { agg: e.target.value })}>
              {AGGREGATIONS.map((a) => <option key={a.key} value={a.key}>{a.label}</option>)}
            </select>
          </label>

          <label>Фильтр по полю
            <select
              value={widget.filter?.by || ""}
              onChange={(e) => set(widget.id, { filter: e.target.value ? { by: e.target.value, value: widget.filter?.value || "" } : null })}
            >
              <option value="">— без фильтра —</option>
              {fields.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
            </select>
          </label>

          {widget.filter?.by && (
            <label>Значение фильтра
              <input
                value={widget.filter?.value || ""}
                onChange={(e) => set(widget.id, { filter: { by: widget.filter.by, value: e.target.value } })}
              />
            </label>
          )}
        </>
      );
    }

    if (widget.type === "group") {
      return (
        <>
          <label>Группировать по
            <select value={widget.groupBy || ""} onChange={(e) => set(widget.id, { groupBy: e.target.value })}>
              {fields.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
            </select>
          </label>

          <label>Метрика
            <select value={widget.metric || "sum"} onChange={(e) => set(widget.id, { metric: e.target.value })}>
              {METRICS.map((m) => <option key={m.key} value={m.key}>{m.label}</option>)}
            </select>
          </label>

          <label>Топ
            <input
              type="number"
              min="1"
              value={widget.topN || 5}
              onChange={(e) => set(widget.id, { topN: Number(e.target.value) || 5 })}
            />
          </label>

          <label>Вид
            <select value={widget.chart || "bar"} onChange={(e) => set(widget.id, { chart: e.target.value })}>
              {CHARTS.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
            </select>
          </label>
        </>
      );
    }

    if (widget.type === "dynamics") {
      return (
        <>
          <label>Столбец-дата
            <select value={widget.dateField || ""} onChange={(e) => set(widget.id, { dateField: e.target.value })}>
              <option value="">— выберите —</option>
              {dateFields.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
            </select>
          </label>

          <label>Период
            <select value={widget.bucket || "day"} onChange={(e) => set(widget.id, { bucket: e.target.value })}>
              {BUCKETS.map((b) => <option key={b.key} value={b.key}>{b.label}</option>)}
            </select>
          </label>

          <label>Метрика
            <select value={widget.metric || "sum"} onChange={(e) => set(widget.id, { metric: e.target.value })}>
              {METRICS.map((m) => <option key={m.key} value={m.key}>{m.label}</option>)}
            </select>
          </label>
        </>
      );
    }

    if (widget.type === "actions") {
      return (
        <label>Источник
          <select value={widget.source || "status"} onChange={(e) => set(widget.id, { source: e.target.value })}>
            <option value="status">Статусы платежа</option>
            {actionColumns.map((c) => <option key={c.id} value={c.id}>{c.label}</option>)}
          </select>
        </label>
      );
    }

    return null;
  };

  return (
    <div className="report-builder">
      <div className="report-builder-add">
        <select value={newType} onChange={(e) => setNewType(e.target.value)}>
          {WIDGET_TYPES.map((t) => <option key={t.key} value={t.key}>{t.label}</option>)}
        </select>
        <button onClick={() => addReportWidget(newWidget(newType))}>Добавить виджет</button>
      </div>

      {widgets.map((widget, index) => (
        <div className="report-widget-edit" key={widget.id}>
          <div className="report-widget-head">
            <input
              value={widget.title || ""}
              onChange={(e) => set(widget.id, { title: e.target.value })}
              placeholder="Заголовок виджета"
            />
            <span className="report-widget-type">
              {WIDGET_TYPES.find((t) => t.key === widget.type)?.label}
            </span>

            <button onClick={() => moveReportWidget(widget.id, -1)} disabled={index === 0}>↑</button>
            <button onClick={() => moveReportWidget(widget.id, 1)} disabled={index === widgets.length - 1}>↓</button>
            <button className="remove-column-btn" onClick={() => removeReportWidget(widget.id)}>Удалить</button>
          </div>

          <div className="report-widget-params">
            {renderParams(widget)}
          </div>
        </div>
      ))}

      {widgets.length === 0 && (
        <p className="report-empty">Виджетов нет. Добавьте первый.</p>
      )}
    </div>
  );
}
